import { SLOT_ROWS } from './rows-slots.js';
import { isWorkPackageId } from './work-packages.js';
/**
 * The document slots: shown for one document, their components given its id. CS r5a (deliverable
 * 148) adds the header's mode switch (`header.modes`, beside the page modes) and the page's tabs
 * (`page.tabs`, the session page's After).
 */
export const DOC_SLOT_IDS = ['header.pills', 'rail.tabs', 'header.modes', 'page.tabs'];
/**
 * The app slots (CS r4a deliverable 109): the sidebar's Workspace group, the Settings page's
 * sections and the catalogue's toolbar; CS r5a (deliverable 148) the top of the sidebar
 * (`shell.top`) and Home's sections (`home.sections`). Their components take no document.
 */
export const APP_SLOT_IDS = [
    'shell.workspace',
    'settings.sections',
    'catalogue.toolbar',
    'shell.top',
    'home.sections',
];
export const SLOT_IDS = [...DOC_SLOT_IDS, ...APP_SLOT_IDS];
/** Seeded slot entries. Feature packages register; integration composes. */
export const SLOTS = SLOT_ROWS;
function isSlotId(value) {
    return typeof value === 'string' && SLOT_IDS.includes(value);
}
/** A runtime registry. It refuses an unknown slot, an unknown owner and a duplicate order. */
export function createSlotRegistry() {
    const entries = new Map();
    return {
        register(entry) {
            if (!isSlotId(entry.slot))
                throw new RangeError(`unknown slot "${String(entry.slot)}"`);
            if (!isWorkPackageId(entry.owner)) {
                throw new RangeError(`unknown owner "${String(entry.owner)}" for slot ${entry.slot}`);
            }
            if (!Number.isFinite(entry.order)) {
                throw new RangeError(`slot ${entry.slot}: order must be a finite number`);
            }
            const list = entries.get(entry.slot) ?? [];
            const clash = list.find((existing) => existing.order === entry.order);
            if (clash) {
                throw new RangeError(`slot ${entry.slot}: order ${entry.order} is taken by ${clash.owner}; ${entry.owner} must pick another`);
            }
            list.push(Object.freeze({ ...entry }));
            entries.set(entry.slot, list);
        },
        list(slot) {
            if (!isSlotId(slot))
                throw new RangeError(`unknown slot "${String(slot)}"`);
            const listed = [...(entries.get(slot) ?? [])].sort((a, b) => a.order - b.order);
            return listed;
        },
    };
}
//# sourceMappingURL=slots.js.map